/**
 * @generated SignedSource<<d7162a934a0ab7c8304e0b0b51bc6150>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type MercuryFocusAreaHealthColor = "GREEN" | "RED" | "YELLOW" | "%future added value";
export type MercuryTargetDateType = "DAY" | "MONTH" | "QUARTER" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage$data = {
  readonly focusArea?: {
    readonly health: {
      readonly color: MercuryFocusAreaHealthColor;
      readonly displayName: string;
      readonly key: string;
    } | null | undefined;
    readonly status: {
      readonly displayName: string;
      readonly key: string;
    };
    readonly targetDate: {
      readonly targetDate: string | null | undefined;
      readonly targetDateType: MercuryTargetDateType | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage";
};
export type searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage$key = {
  readonly " $data"?: searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "key"
},
v1 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "MercuryFocusArea",
          "kind": "LinkedField",
          "name": "focusArea",
          "plural": false,
          "selections": [
            {
              "concreteType": "MercuryFocusAreaStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            },
            {
              "concreteType": "MercuryFocusAreaHealth",
              "kind": "LinkedField",
              "name": "health",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "color"
                },
                (v1/*: any*/)
              ]
            },
            {
              "concreteType": "MercuryTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "targetDate"
                },
                {
                  "kind": "ScalarField",
                  "name": "targetDateType"
                }
              ]
            }
          ]
        }
      ],
      "type": "SearchResultMercuryFocusArea"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};
})();

(node as any).hash = "1ba6f6deb1ce6324e34fc596e49e59a6";

export default node;
